import { FC } from "react";
import { IStatusBarProps } from "./types";

const StatusBar: FC<IStatusBarProps> = ({ children }) => (
  <div className="flex bg-yellowLight text-grayDark w-full px-2 mb-2 rounded">{children}</div>
);

export default StatusBar;
